import useScrollRestoration from 'hooks/common/useScrollRestoration';
import PAGES from 'pages/registry';
import { useEffect, useRef } from 'react';
import { Route, Routes, useNavigate } from 'react-router-dom';
import TABS from 'tabs/registry';

function Navigation() {
  const navigate = useNavigate();
  const { store } = useScrollRestoration();
  const initedRef = useRef(false);

  // 프로그램적 히스토리 되감기(navigate(-1))도 popstate를 발생시키는데,
  // Android 뒤로가기 에뮬레이션(device.js popstate 핸들러)이 이를 사용자의 뒤로가기로
  // 오인해 홈 이동/종료 확인이 뜨는 문제가 있어(React 탭 전환 시 재현) 표식을 남긴다.
  // device.js가 카운터를 보고 해당 popstate를 무시한다.
  function navigateBack() {
    const w = window as any;
    w.__programmaticBackCount = (w.__programmaticBackCount || 0) + 1;
    w.__programmaticBackAt = Date.now();
    navigate(-1);
  }

  useEffect(() => {
    if (initedRef.current) return;
    initedRef.current = true;

    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function init() {
    // React 탭을 Webapp Transition 모듈에 등록.
    TABS.forEach((tab) => {
      Transition.registerTab(tab.path, {
        start: (data: any, isReactTabNavigation: boolean) => {
          navigate(tab.path, { state: data, replace: isReactTabNavigation });
        },
        show: (data: any, isReactTabNavigation: boolean) => {
          if (!isReactTabNavigation) {
            navigateBack();
          }
        },
        stop: (isReactTabNavigation: boolean) => {
          if (!isReactTabNavigation) {
            const history = Transition.getHistory();
            if (history.length > 1 && history[history.length - 1].page) {
              // 마지막 히스토리가 페이지인 경우 navigate(-1)을 호출하면 숨겨둔 react page가 보여지게 되므로 그냥 리턴한다.
              return;
            }
            navigateBack();
          }
        },
        hide: (isReactTabNavigation: boolean) => {
          store(tab.path);
          if (!isReactTabNavigation) {
            navigate('/');
          }
        }
      });
    });
    // React 페이지를 Webapp Transition 모듈에 등록.
    PAGES.forEach((page) => {
      Transition.registerPage(page.path, {
        path: page.path,
        show: (data: any, type: 'push' | 'pop', isReactPageNavigation: boolean) => {
          if (type === 'push') {
            navigate(page.path, { state: data });
          } else {
            if (!isReactPageNavigation) {
              navigateBack();
            }
          }
        },
        hide: (type: 'hide' | 'dispose' | 'reset', isReactPageNavigation: boolean) => {
          if (type === 'hide' || type === 'reset') {
            store(page.path);
            if (!isReactPageNavigation) {
              navigate('/');
            }
          } else {
            navigateBack();
          }
        },
      });
    });

    // vanila.js 에서 useNavigate 사용하도록
    Transition.setNavigate(navigate);
  }

  return (
    <>
      <Routes>
        {PAGES.map((page, index) => (
          <Route key={index} path={page.path} element={<page.element />} />
        ))}
        {TABS.map((tab, index) => (
          <Route key={index} path={tab.path} element={ <tab.element />} />
        ))}
      </Routes>
    </>
  );
}

export default Navigation;
